(function(){
  const STORAGE_KEY = 'wishlist';

  function getWishlist(){
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch(e){
      return [];
    }
  }

  function saveWishlist(list){
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list } }));
  }

  function toggleWishlist(handle){
    let list = getWishlist();
    if(list.includes(handle)){
      list = list.filter(h => h !== handle);
    } else {
      list.push(handle);
    }
    saveWishlist(list);
    return list.includes(handle);
  }

  window.Wishlist = {
    getWishlist,
    toggleWishlist,
    removeFromWishlist: function(handle){
      saveWishlist(getWishlist().filter(h => h !== handle));
    }
  };

  function syncButtons(){
    const list = getWishlist();
    document.querySelectorAll('.wishlist-btn[data-handle]').forEach(btn => {
      btn.classList.toggle('active', list.includes(btn.dataset.handle));
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = list.length;
    });
  }

  document.addEventListener('DOMContentLoaded', syncButtons);
  document.addEventListener('wishlist:updated', syncButtons);

  // Event delegation — dynamically added / Swiper-cloned buttons bhi kaam karenge
  document.addEventListener('click', function(e){
    const btn = e.target.closest('.wishlist-btn[data-handle]');
    if(!btn) return;
    e.preventDefault();
    toggleWishlist(btn.dataset.handle);
  });
})();